// The Jobs page's client-side filter over one already-fetched day partition.
// `status` is normally applied server-side too; kept here so the status select
// re-filters instantly without a refetch. `text` is a free substring match over
// the route id and the error code - debounced by the caller per the UI standard.

import type { Job } from "./types.js";

export interface JobFilter {
  status?: string;
  text?: string;
}

export function filterJobs(jobs: Job[], { status, text }: JobFilter): Job[] {
  const needle = (text ?? "").trim().toLowerCase();
  return jobs.filter((job) => {
    if (status && job.status !== status) return false;
    if (needle) {
      const haystack = `${job.routeId} ${job.error?.code ?? ""}`.toLowerCase();
      if (!haystack.includes(needle)) return false;
    }
    return true;
  });
}
